import { SimOptionAction } from "../actions/SimOptionAction";
import { SequenceManagerAction } from "../actions/SequenceManagerAction";

const initSimType = {
    requestBody: {
        sectionId: "SimOption",
        steps: [
            {
                sequence: "0",
                offerContainerId: "",
                stepId: "ChooseSIMType",
                options: [
                    {
                        name: "SIM Type",
                        value: "",
                    },
                ],
            },
        ],
    }
};

const SimOptionReducer = (state: any = initSimType, action: any) => {
    const { type } = action;
    const { payload } = action;
    var SimOptionValue = { ...state.requestBody.steps };

    switch (type) {
        case SimOptionAction.SELECT_SIM_TYPE:
            SimOptionValue[0].options[0].value = payload.selection;
            SimOptionValue[0].offerContainerId = payload.offerContainerId;
            return state;

        case SequenceManagerAction.GET_CHECKOUT_SUCCESS:
            let section = payload.sections.filter((section: any) => {
                return (section.sectionId === 'SimOption')
            });
            if (section.length > 0) {
                let simValueType = section[0].steps[0].options[0];
                SimOptionValue[0].offerContainerId = section[0].steps[0].offerContainerId;
                SimOptionValue[0].options[0].value = simValueType ? simValueType.value : "";
            }
            return state;

        default:
            return state;
    }
};

export default SimOptionReducer;
